import React, { useCallback, useContext } from 'react';
import t from 'react-translate';
import { AngularServicesContext } from 'react-app';

// redux
import { useSelector } from 'react-redux';
import { getCurrentCourse, getFlatCourseAliases } from 'redux/selectors/course';
import { useAppDispatch } from 'redux/store';

// hooks
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';
import { hideAddUI } from 'lecture_pages/templates/components/nv-add-component';

// components
import { config } from '../../../../../config/config.json';
import TopPanelActionButton from './top-panel-action-button';

const BackToCourseOutlineButton = () => {
  const params = useLecturePageParams();
  const { $state } = useContext(AngularServicesContext);
  const dispatch = useAppDispatch();

  const currentCourse = useSelector(state => getCurrentCourse(state));
  const courseAliases = useSelector(state => getFlatCourseAliases(state, params.catalogId));

  /** Navigate to the course outline (course home page) in edit mode */
  const outlineHref = useCallback(() => {
    hideAddUI(dispatch);

    return $state.go(
      currentCourse.isProgram ? 'program-timelines-edit' : 'course-home-edit',
      { catalogId: params.catalogId },
    );
  }, [$state, currentCourse.isProgram, dispatch, params.catalogId]);

  return (
    <React.Fragment>
      <TopPanelActionButton
        icon='home'
        tooltipText={t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.BACK_TO_OUTLINE(courseAliases)}
        onClick={outlineHref}
        useDefaultStyle={false}
        className='p-4 mr-2'
        dataQa={config.pendo.lectureEdit.editMenuTopPanel.backToCourseOutlineHome}
        ariaLabel={t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.BACK_TO_OUTLINE(courseAliases)}
      />
    </React.Fragment>
  );
};

export default BackToCourseOutlineButton;
